$(function(){
  $(window).on('load',function(){
    $('.lifestyle_mv').addClass('mvShow');
    
    var $slide = $('.main_slide').slick({
      slidesToShow: 1,
      arrows: false,
      autoplay: true,
      fade: true,
      speed: 2000,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false
      })
    .on({
      beforeChange: function(event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
        $(".slick-slide", this).eq(nextSlide).addClass("slide-animation");
      },
      afterChange: function() {
        $(".preve-slide", this).removeClass("preve-slide　slide-animation");
      }
    });
    $slide.find(".slick-slide").eq(0).addClass("slide-animation");
    $('.side_ttl').slick({
      slidesToShow: 1,
      arrows: false,
      autoplay: true,
      fade: true,
      speed: 2000,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false
    });
    var $slide3 = $('.side_sub').slick({
      slidesToShow: 1,
      arrows: false,
      autoplay: true,
      fade: true,
      speed: 2000,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false
      })
    .on({
      beforeChange: function(event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
        $(".slick-slide", this).eq(nextSlide).addClass("slide-animation");
      },
      afterChange: function() {
        $(".preve-slide", this).removeClass("preve-slide　slide-animation");
      }
    });
    $slide3.find(".slick-slide").eq(0).addClass("slide-animation");

    function sliderSetting(){
      var width = $(window).width();
      if(width >= 750){
        $('.lifestyle_itemWrap').not('.slick-initialized').slick({
          slidesToShow: 4,
          centerMode: true,
          centerPadding: '0',
          prevArrow: '<div class="lifestyle_arrow lifestyle_arrow-prev"><img src="https://cdn.shopify.com/s/files/1/0508/7048/5144/files/lifestyle_arrow.svg?v=1635240659"></div>',
          nextArrow: '<div class="lifestyle_arrow lifestyle_arrow-next"><img src="https://cdn.shopify.com/s/files/1/0508/7048/5144/files/lifestyle_arrow.svg?v=1635240659"></div>'
        });
      } else {
        $('.lifestyle_itemWrap.slick-initialized').slick('unslick');
      }
    }
    sliderSetting();
    $(window).on('resize',function(){
      sliderSetting();
    });
  });
  
  $(window).on('scroll',function(){
    $(".anime").each(function(){
      var imgPos = $(this).offset().top;    
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > imgPos - windowHeight + windowHeight/3){
        $(this).addClass("anime_start");
      }
    });
    $(".lifestyle_article-ttl").each(function(){
      var imgPos2 = $(this).offset().top;    
      var scroll2 = $(window).scrollTop();
      var windowHeight2 = $(window).height();
      if (scroll2 > imgPos2 - windowHeight2 + windowHeight2/3){
        $(this).addClass("move_start");
      }
    });
  });
});
